/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListMcpServersForOrgSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListMcpServersForOrgRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListMcpServersForOrgSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListMcpServersForOrgSecurity$outboundSchema: z.ZodMiniType<
  ListMcpServersForOrgSecurity$Outbound,
  ListMcpServersForOrgSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listMcpServersForOrgSecurityToJSON(
  listMcpServersForOrgSecurity: ListMcpServersForOrgSecurity,
): string {
  return JSON.stringify(
    ListMcpServersForOrgSecurity$outboundSchema.parse(
      listMcpServersForOrgSecurity,
    ),
  );
}

/** @internal */
export type ListMcpServersForOrgRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListMcpServersForOrgRequest$outboundSchema: z.ZodMiniType<
  ListMcpServersForOrgRequest$Outbound,
  ListMcpServersForOrgRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function listMcpServersForOrgRequestToJSON(
  listMcpServersForOrgRequest: ListMcpServersForOrgRequest,
): string {
  return JSON.stringify(
    ListMcpServersForOrgRequest$outboundSchema.parse(
      listMcpServersForOrgRequest,
    ),
  );
}
